import React from 'react';

const Model = () => (
    <svg id="Layer_3" data-name="Layer 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <rect width="24" height="24" transform="translate(24 24) rotate(180)" fill="none" />
        <path
            d="M9.75,7V9a.5.5,0,0,1-.5.5H6.75a.5.5,0,0,1-.5-.5V7"
            fill="none"
            stroke="#323232"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
        <rect
            x="3"
            y="7"
            width="10"
            height="14"
            rx="2"
            strokeWidth="1.5"
            stroke="#323232"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
        <path
            d="M17.74952,2V4a.5.5,0,0,1-.5.5h-2.5a.5.5,0,0,1-.5-.5V2"
            fill="none"
            stroke="#323232"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
        <path
            d="M16,16h3a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2"
            fill="none"
            stroke="#323232"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Model;
